import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mergeServerLog, recycleList, deleteMergeServerLog, setMergeServer } from "@/api/gmtool/packageCode";
import addServicePreview from "./components/addServicePreview";
import contentView from "./components/contentView";
import { gmTool } from "@/mixins/index";
export default {
  name: "servicePreviewList",
  components: {
    addServicePreview: addServicePreview,
    contentView: contentView
  },
  mixins: [gmTool],
  data: function data() {
    return {
      advanced: false,
      dialog: false,
      total: 0,
      list: [],
      paramsData: {
        page: 1,
        start_time: "",
        end_time: ""
      },
      value2: [],
      selsString: "",
      TopLevelNot: true
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getserverList();

            case 2:
              _this.getList();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  beforeDestroy: function beforeDestroy() {},
  methods: {
    // 关闭弹窗
    changeShow: function changeShow(val) {
      this.dialog = val;
    },
    // async switchSerive() {
    //   this.currentPage = 1;
    //   await this.getserverList();
    //   this.getList();
    // },
    Renewal: function Renewal() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.getserverList();

              case 2:
                _this2.getList(1);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getList: function getList(e) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.paramsData.page = e;
                _this3.reqLoading = true;
                mergeServerLog(_this3.paramsData).then(function (res) {
                  if (res.status == 200) {
                    res.data.data.map(function (item) {
                      if (Array.isArray(item.email_content)) {
                        item.content_Val = item.email_content.length == 0 ? [] : item.email_content[0].title_content;
                      } else {
                        item.content_Val = item.email_content ? item.email_content.title_content : [];
                      }
                    });
                    _this3.tableData = res.data.data;
                    _this3.total = res.data.total;
                  }
                }).finally(function () {
                  _this3.reqLoading = false;
                });

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    sendService: function sendService(id) {
      var _this4 = this;

      this.$confirm(this.$t('confirmSendMergePreview'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                setMergeServer({
                  id: id
                }).then(function (res) {
                  if (res.code == 200) {
                    _this4.$message({
                      type: "success",
                      message: _this4.$t('sendSuccess')
                    });

                    _this4.getList();
                  }
                });

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      })));
    },
    // 删除
    handleDelete: function handleDelete(id) {
      var _this5 = this;

      this.$confirm(this.$t('confirmDeleteMergeServer'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                deleteMergeServerLog({
                  id: id
                }).then(function (res) {
                  if (res.status == 200) {
                    _this5.getList();

                    _this5.$message({
                      type: "success",
                      message: _this5.$t('deleteSuccess')
                    });
                  }
                });

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      })));
    }
  }
};